var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',{directives:[{name:"t",rawName:"v-t",value:({ path:'message.welcome', args: { m: _vm.$t('serviceName.marito') } }),expression:"{ path:'message.welcome', args: { m: $t('serviceName.marito') } }"}],staticClass:"title"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }